import {
	BifrostBackendApi,
	BifrostBackendViaCdnApi
} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const PriceRulesProvider = {
	async findAll(queryData = {}, useApiCdnCaching) {
		const res = await (useApiCdnCaching
			? BifrostBackendViaCdnApi
			: BifrostBackendApi
		).get("/price-rules", {
			params: {
				$limit: "10000",
				...queryData,
				tenantId: appConfig.tenantId
			}
		});

		return res.data;
	},

	async insert({
		orderingDatePattern,
		weekDay,
		shopPattern,
		productPattern,
		discountValue,
		discountType,
		voucherPattern,
		productSpecific,
		customerPattern,
		options,
		dateRule
	}, jwtToken) {
		return BifrostBackendApi.post(
			`/price-rules`,
			{
				tenantId: appConfig.tenantId,
				orderingDatePattern,
				weekDay,
				shopPattern,
				productPattern,
				discountType,
				discountValue,
				voucherPattern,
				productSpecific,
				customerPattern,
				options,
				dateRule
			},
			{
				headers: {
					Authorization: jwtToken
				}
			}
		);
	},

	async delete(id, jwtToken) {
		return BifrostBackendApi.delete(`/price-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async get(id, jwtToken) {
		return BifrostBackendApi.get(`/price-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async update(id, data, jwtToken) {
		return BifrostBackendApi.put(
			`/price-rules/${id}?tenantId=${data.tenantId}`,
			data,
			{
				headers: {
					Authorization: jwtToken
				}
			}
		);
	}
};

export default Object.freeze(PriceRulesProvider);
